import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isActivateProjectResourceRequestFailure({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isActivateProjectResourceRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isActivateProjectResourceRequestPending({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
